<template>
  <div>
    <!-- 子评论 -->
    <div class="reply-list">
      <div v-for="(reply, index) in replyList" :key="reply.id">
        <hr v-if="index" class="reply-hr" />
        <Reply
          class="reply"
          :reportId="reportId"
          :reply="reply"
          @successSendNewReply="getReplyList(listPagination.pageNo)"
        />
      </div>
    </div>
    <!-- 点击查看更多回复 -->

    <div class="reply-list-footer">
      <span>共{{ total }}条回复</span>
      <!-- 子评论的分页 -->
      <el-pagination
        layout="pager"
        :current-page="listPagination.pageNo"
        :page-count="listPagination.pageTotalSize"
        :page-size="listPagination.pageSize"
        @current-change="getReplyList"
      >
      </el-pagination>
      <el-button size="mini" @click="showReplyForm = !showReplyForm"
        >我也说一句</el-button
      >
    </div>
    <!-- 回复子评论表单 -->
    <NewReply
      v-if="showReplyForm"
      :reportId="reportId"
      @successSendNewReply="getReplyList(listPagination.pageNo)"
    />
  </div>
</template>

<script>
import * as queryString from "query-string";

import Reply from "./Reply";
import NewReply from "./NewReply";

export default {
  props: {
    reportId: {
      type: Number,
      required: true,
    },
  },
  components: {
    Reply,
    NewReply,
  },
  data() {
    return {
      total: 0,
      replyList: [],
      listPagination: {
        pageNo: 1,
        pageSize: 10,
        pageTotalSize: 0,
      },

      showReplyForm: false,
    };
  },
  methods: {
    async getReplyList(currentIndex) {
      this.listPagination.pageNo = currentIndex ? currentIndex : 1;

      const response = await this.axios.get(
        queryString.stringifyUrl({
          url: `/api/selectReportInfoByReportId/${this.reportId}`,
          query: this.listPagination,
        })
      );

      switch (response.data.code) {
        case 200: //发送成功后返回
          {
            const {
              data,
              pageNo,
              pageSize,
              pageTotalSize,
              total,
            } = response.data.data;
            this.replyList = data;
            this.listPagination.pageNo = pageNo;
            this.listPagination.pageSize = pageSize;
            this.listPagination.pageTotalSize = pageTotalSize;
            this.total = total;
          }
          break;

        case -100:
          this.$message({
            message: "评论获取失败",
            type: "error",
          });
          break;
      }
    },
  },
  created() {
    this.getReplyList();
  },
};
</script>

<style scoped>
.reply-list {
  margin-top: 10px;
}
.reply-hr {
  margin: 10px 10px;
}
.reply-list-footer {
  display: flex;
  justify-content: space-between;
}
</style>